@if (showModal) {
  <div
    class="fixed top-0 left-0 flex items-center justify-center w-full h-full z-1001 bg-black/70 backdrop-blur-lg"
    >
    <!-- Overlay Background to Close Modal on Click -->
    <div
      class="fixed w-full h-full bg-transparent z-1002"
      (click)="closeModal()"
    ></div>
    <!-- Control Buttons (Previous, Next, Close) -->
    <div
      class="fixed flex items-center pt-16 text-3xl font-bold text-white z-1003 top-6 right-8 space-x-4"
      >
      @if (picturesInLightbox.length > 1) {
        <button (click)="previousImage()">
          <mat-icon svgIcon="mat:skip_previous"></mat-icon>
        </button>
      }
      @if (picturesInLightbox.length > 1) {
        <button (click)="nextImage()">
          <mat-icon svgIcon="mat:skip_next"></mat-icon>
        </button>
      }
      <button (click)="closeModal()">
        <mat-icon svgIcon="mat:close"></mat-icon>
      </button>
    </div>
    <!-- Main Content Wrapper with Max Width and Height Constraints -->
    <div
      class="flex flex-col items-center w-full max-w-4xl p-4 pt-24 space-y-4 z-1004 xl:pt-16"
      >
      <!-- Large Image Display with Max Height/Width to Prevent Oversizing -->
      @if (picturesInLightbox[currentImageIndex]; as currentImage) {
        <div
          class="relative flex items-center justify-center w-full h-full"
          >
          <!-- Large Image Display with Max Height/Width to Prevent Oversizing -->
          <img
        [src]="
          currentImage.filename + currentImage.ext | photoProxy : '1920:1080'
        "
            [alt]="currentImage.filename + currentImage.ext"
            class="max-w-full max-h-[70vh] object-contain"
            />
          <!-- Icon Positioned Over the Image -->
          @if (currentImage.isPublic) {
            <mat-icon
              class="absolute bottom-2 right-2 opacity-70 text-contrast-white hover:opacity-100 hover:text-green-600 transition-all duration-300 ease-in-out"
              matTooltip="Dílo je veřejné"
              svgIcon="mat:language"
            ></mat-icon>
          }
        </div>
      }
      <!-- Thumbnail Scroller with Width Constraints and Overflow Handling -->
      <div
        class="flex w-full max-w-3xl p-2 overflow-x-auto space-x-2 scrollbar-thin"
        >
        @for (img of picturesInLightbox; track img; let i = $index) {
          <button
            class="relative flex-none w-24 h-24 border-2 border-transparent focus:border-white"
            (click)="currentImageIndex = i"
            >
            <img
              class="object-contain w-full h-full"
              [src]="img.filename + img.ext | photoProxy"
              [alt]="img.filename + img.ext"
              />
            @if (img.isPublic) {
              <mat-icon
                class="absolute bottom-2 right-2 opacity-70 text-contrast-white hover:opacity-100 hover:text-green-600 transition-all duration-300 ease-in-out"
                matTooltip="Dílo je veřejné"
                svgIcon="mat:language"
              ></mat-icon>
            }
          </button>
        }
      </div>
    </div>
  </div>
}
